import {IPoint} from "../interfaces/IPoint";
import {Geodesic} from "..";
import {Log} from "../Tools/Log";

const R = 25;
const MAX_BEARABLE_LENGTH = 30000;  //We can't analyze loops on tracks longer than 40 kms.

export class LoopsAnalyzer {

    private readonly refPointList: IPoint[];   //The points that were provided initially.



    constructor(pointList:IPoint[]) {
        this.refPointList = pointList;
    }

    findBreakingIndex(subRefPointList: IPoint[]) {
        // Log.log("Working on subset of length " + subRefPointList.length);
        let refDA = Geodesic.distanceArray(subRefPointList);   //All the linear distances of the reference point list.
        let refLen = Geodesic.pointListMetersLen(subRefPointList);  //The distance convered by this track. If the distance is too important, we will disable density increasing due to loss of performance.
        let densePointList = null;
        if(refLen >= MAX_BEARABLE_LENGTH) {
            densePointList = Geodesic.increaseDuetListDensity(subRefPointList, MAX_BEARABLE_LENGTH);  //At least one point every MAX_BEARABLE_LENGTH (meaning no things)
        } else {
            densePointList = Geodesic.increaseDuetListDensity(subRefPointList, R);  //At least one point every R/2 meters
        }

        // Log.log("dense subset point count : " + densePointList.length);
        let denseDA = Geodesic.distanceArray(densePointList);  // All the linear distances of the dense point list
        let rDMatrix = Geodesic.relativeDistanceMatrix(densePointList); // All the relative distances of each point one another. (heavy to compute)
        // Log.log("constants were computed.");
        let breakingIndex = -1;
        let maxJ = -1;
        for(let i = 0; i < densePointList.length; i++) {
            if(maxJ != -1 && maxJ >= i) {
                break;  //Those points are ignored since they were found breaking up.
            }
            //For each point, we search the ones that are geographically closer than R
            for(let j = i + 1; j < densePointList.length; j++) {
                if(rDMatrix[i][j] <= R) {   //point[j] is closer than R to point[i]
                    if(Math.abs(denseDA[i]- denseDA[j]) > R*2) {
                        // Log.log("Found that point at index " + j + " on densified polyline is at a relative distance of " + rDMatrix[i][j] + " of point " + i + ", and it's distance on shape is " +
                        //     denseDA[j] + " while " + i + " is at distance " + denseDA[i] + "meters distance those points is " + (denseDA[i]- denseDA[j]));
                        //But point[j] is not close on the distance array, we can therefore remove points on refDA with distance >= denseDA[j].
                        for(let k = 0; k < refDA.length; k++) {
                            // console.log(denseDA[j], refDA[k]);
                            if(refDA[k] >= denseDA[j] - 1) {
                                /**
                                 * Points from subRefPointList [k, +oo [ should be ignored.
                                 * Points from densePointList after j can be ignored (i >= j)
                                 */
                                breakingIndex = (breakingIndex === -1 || k < breakingIndex) ? k : breakingIndex;  //Updating breaking index since it's now lower.
                                break;                                                  //Breaking
                            }
                            if(k === refDA.length - 1) {
                                Log.die("Unable to find a point at it's distance. This is not possible.");
                            }
                        }
                        maxJ = j < maxJ ? j : maxJ;                 //Updating maxJ if this j is below the previous one.
                        break;
                    }
                }
            }
        }
        // console.log("Returning ", breakingIndex);
        return breakingIndex;  //There is no points that doesn't respect
    }

    analyse(): IPoint[][] {
        let pointClusters: IPoint[][] = [];
        let handledPointsAmount = 0;
        let workingSet = this.refPointList.slice();                //The initial points we'll work on
        let reducedSet = this.refPointList.slice();                //Before breaking, the reduced set is equal to it.
        let remainingSet: IPoint[] = [];                           //The remaining set (point removed by the breakindex finder) is empty at first
        for(let i = 0; i < this.refPointList.length; i++) {
            let breakIndex = this.findBreakingIndex(reducedSet);    //Search for a potential break index
            if(breakIndex !== -1) {
                reducedSet = workingSet.slice(0, breakIndex);       // Element at position "breakIndex" will not be included.
                remainingSet = workingSet.slice(breakIndex);        // The rest of the elements
            }

            pointClusters.push(reducedSet.slice());                 // This is a cluster of points without loops in it.
            handledPointsAmount += reducedSet.length;               // We count the amount of points that were already clusterized
            // console.log(handledPointsAmount);
            if(handledPointsAmount === this.refPointList.length) {
                break;                                              // Every point is in a cluster
            }
            workingSet = remainingSet.slice();                      // The remaining set becomes the new working set.
            reducedSet = remainingSet.slice();                      // And also the new reduced set.
            remainingSet = [];                                      // The new remaining set is empty

        }
        if(handledPointsAmount < this.refPointList.length) {
            Log.die("Handled point amount is too low.");
        }

        return pointClusters;



    }




}
